import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=ede1e674&scoped=true&"
import script from "./FileDownload.vue?vue&type=script&lang=js&"
export * from "./FileDownload.vue?vue&type=script&lang=js&"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=ede1e674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede1e674",
  null
  
)

export default component.exports